
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms",
      function () {
        return require("private-next-pages/terms.tsx");
      }
    ]);
  